import { WebGLRenderTarget, Object3D, Vector3 } from "three"
import React, { useRef, useLayoutEffect } from "react"
import { useLoader, useThree, useFrame } from "@react-three/fiber"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import lerp from "lerp"
import BackfaceMaterial from "./BackfaceMaterial"
import RefractionMaterial from "./RefractionMaterial"
import useMaterials from "./useMaterials"
import { useBlock } from "../blocks"
import useContentStore from "../redux/stores/contentStore"

const dummy = new Object3D();

export default function Diamonds() {
  const { content, sectionsOffsets } = useContentStore((state) => state)
  const gltf = useLoader(GLTFLoader, content.model)
  const mainNode = gltf.scene.children[0];
  const sectionsDiamonds = content.paragraphs.filter( ({diamond}) => diamond).map(({diamond}) => diamond);
  const introDiamond = { x: 3, offset: 0.05, pos: new Vector3(), scale: 2.5, factor: 4 };
  const outroDiamond = { x: 0, offset: 0, pos: new Vector3(), rotateY: true, scale: 2.5, factor: 6 };

  useLayoutEffect(() => {
      mainNode.geometry.center()
  }, [])

  const {
      gl,
      scene,
      camera,
      clock
  } = useThree()
  const {
      contentMaxWidth,
      sectionHeight,
      mobile
  } = useBlock()
  const model = useRef()

  const [envFbo, backfaceFbo, backfaceMaterial, refractionMaterial] = useMaterials();

  const configDiamond = (data, i, baseOffset = 0) => {
      const t = clock.getElapsedTime() / 2
      const { x, offset: dataOffset, scale, factor } = data
      const offset = dataOffset + baseOffset;
      const s = (contentMaxWidth / 35) * scale
      data.pos.set(mobile ? 0 : x, lerp(data.pos.y, -sectionHeight * offset * factor + (content.top.current / content.zoom) * factor, 0.1), 0)
      dummy.position.copy(data.pos)
      if (data.rotateY) dummy.rotation.set(0, t, 0)
      else dummy.rotation.set(t, t, t)
      dummy.scale.set(s, s, s)
      dummy.updateMatrix()
      model.current.setMatrixAt(i, dummy.matrix)
      model.current.instanceMatrix.needsUpdate = true
  }

  useFrame(() => {
      const time = clock.getElapsedTime() / 2
      configDiamond(introDiamond, 0);
      sectionsDiamonds.forEach((data, i) => {
          configDiamond(data, i + 1, sectionsOffsets[i]);
      });
      configDiamond(outroDiamond, sectionsDiamonds.length + 1, sectionsOffsets[sectionsOffsets.length - 1] + 1);
      gl.autoClear = false
      camera.layers.set(0)
      gl.setRenderTarget(envFbo)
      gl.clearColor()
      gl.render(scene, camera)
      gl.clearDepth()
      camera.layers.set(1)
      model.current.material = backfaceMaterial
      gl.setRenderTarget(backfaceFbo)
      gl.clearDepth()
      gl.render(scene, camera)
      camera.layers.set(0)
      gl.setRenderTarget(null)
      gl.render(scene, camera)
      gl.clearDepth()
      camera.layers.set(1)
      model.current.material = refractionMaterial
      gl.render(scene, camera)
  }, 1)

  return <instancedMesh ref={model} layers={1} args={[mainNode.geometry, null, sectionsDiamonds.length + 2]} position={[0, 0, 50]} />
}
